import React from 'react';
import { useHistory, useParams } from 'react-router';
import ResetPasswordForm from './auth/ResetPasswordForm';
import AuthContent from './layout/AuthContent';

const ResetPassword = () => {
    //Tomo los params
    const params = useParams();
    //Tomo el history
    const history = useHistory();
    //Me fijo que esté el token
    if(!params.token || params.token.length !== 32){
        //Redirecciono
        history.push('/');
    }
    //Renderizo
    return (
        <AuthContent
            component={ResetPasswordForm}
            token={params.token}
        />
    );
};

export default ResetPassword;